import { TRUSTED_BY, CLIENT_GROUPS } from "@/lib/site";

export default function TrustedBy() {
  const list = [...TRUSTED_BY, ...TRUSTED_BY];
  return (
    <>
      {/* Marquee strip */}
      <section data-testid="trusted-by-section" className="relative bg-[#0A1128] py-10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-4">
          <div className="overline text-slate-400">// Deployed with</div>
        </div>
        <div className="relative w-full overflow-hidden">
          <div className="flex marquee-track gap-12 whitespace-nowrap">
            {list.map((name, i) => (
              <div key={i} className="flex items-center gap-4 shrink-0">
                <span className="w-2 h-2 bg-red-500 rotate-45" />
                <span className="font-display font-bold uppercase tracking-tight text-slate-100 text-2xl md:text-3xl">
                  {name}
                </span>
              </div>
            ))}
          </div>
          <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0A1128] to-transparent pointer-events-none" />
          <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0A1128] to-transparent pointer-events-none" />
        </div>
      </section>

      {/* Detailed clientele block */}
      <section id="clientele" className="relative py-24 md:py-32 bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <div className="overline mb-3 text-red-600">// 04 · Clientele</div>
              <h2 className="font-display font-black uppercase text-[#0A1128] text-4xl md:text-5xl tracking-tighter leading-[0.95]">
                Serving the agencies that <span className="text-red-600">protect India.</span>
              </h2>
            </div>
            <p className="text-slate-600 text-sm md:text-base max-w-md leading-relaxed">
              From bomb-disposal squads to airport security and border forces, our equipment is operational at checkpoints, perimeters and crime scenes across the country.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
            {CLIENT_GROUPS.map((g, idx) => (
              <div key={g.title} className="bg-white p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="font-mono-tactical text-[10px] tracking-[0.25em] text-slate-400">// {String(idx + 1).padStart(2, "0")}</span>
                  <span className="w-2 h-2 bg-red-600 rotate-45" />
                </div>
                <h3 className="font-display font-bold uppercase text-[#0A1128] text-base tracking-tight mb-4">
                  {g.title}
                </h3>
                <ul className="space-y-2">
                  {g.items.map((it) => (
                    <li key={it} className="text-slate-700 text-sm border-l-2 border-slate-200 pl-3">{it}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
